// extracted by mini-css-extract-plugin
export var container = "_2x-0";
export var error = "_2x-9";
export var label = "_2x-5";
export var light = "_2x-6";
export var md = "_2x-3";
export var sm = "_2x-2";
export var thin = "_2x-8";
export var thinBold = "_2x-7";
export var vertical = "_2x-4";
export var xs = "_2x-1";